import { useTranslation } from "react-i18next";
import * as yup from "yup";

const useReleaseSoundRecordingSchema = () => {
    const { t } = useTranslation();

    return yup.object({
        duration: yup.mixed().required(t("messages.inputMsgs.required")),
        track: yup.string().required(t("messages.inputMsgs.required")),
    });
};

export default useReleaseSoundRecordingSchema;
